import { render, staticRenderFns } from "./GridHistorico.vue?vue&type=template&id=d1a790aa"
import script from "./GridHistorico.vue?vue&type=script&lang=js"
export * from "./GridHistorico.vue?vue&type=script&lang=js"
import style0 from "./GridHistorico.vue?vue&type=style&index=0&id=d1a790aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports